import { Injectable } from '@angular/core';
import * as _ from 'lodash';

@Injectable()
export class MaskingService {
  constructor() {
    this.pathMaps = [
      { regex: /ssn$/i, func: this.ssnMasking },
      { regex: /(routingNumber|accountNumber)$/i, func: a => a }, // Dont want it to actually mask
      { regex: /(dob|date)$/i, func: this.dateFieldsMasking },
      { regex: /phone$/i, func: this.phoneNumberMasking },
      { regex: /employedSince$/i, func: this.employedSinceMasking },
      { regex: /dependents$/i, func: this.dependentsMasking }
    ];
  }

  // Masking Service Helpers

  isMasked(path) {
    return this._getMaskingFunction(path) != null;
  }

  maskInput(path, value) {
    let newValue = value;
    newValue = newValue.replace(/\s{2,}/g, ' ');
    const maskFunc = this._getMaskingFunction(path);
    if (maskFunc != null) {
      newValue = this.removeSpecial(newValue);
      newValue = maskFunc(newValue);
    }

    return newValue;
  }

  _getMaskingFunction(path) {
    const maskFunc = _.find(this.pathMaps, map => {
      return map.regex.exec(path);
    });

    return (maskFunc || {}).func;
  }

  // Actual masking functions

  removeSpecial(value) {
    const inputStr = value.replace(/\D/g, '');
    return inputStr;
  }

  dateFieldsMasking(value) {
    let maskedInput = value.split('');
    if (maskedInput.length > 1) {
      maskedInput.splice(2, 0, '/');
      if (maskedInput.length > 4) {
        maskedInput.splice(5, 0, '/');
      }
    }
    maskedInput = maskedInput.join('');
    return maskedInput;
  }

  ssnMasking(value) {
    let maskedInput = value.split('');
    if (maskedInput.length > 2) {
      maskedInput.splice(3, 0, '-');
      if (maskedInput.length > 5) {
        maskedInput.splice(6, 0, '-');
      }
    }
    maskedInput = maskedInput.join('');
    return maskedInput;
  }

  dependentsMasking(value) {
    let maskedInput = value.split('');
    // remove leading 0
    if (maskedInput[0] === '0' && maskedInput.length > 1) {
      maskedInput = maskedInput.slice(1);
    }

    maskedInput = maskedInput.join('');
    return maskedInput;
  }

  phoneNumberMasking(value) {
    let maskedInput = value.split('');
    if (maskedInput.length > 2) {
      maskedInput.splice(3, 0, '-');
      if (maskedInput.length > 6) {
        maskedInput.splice(7, 0, '-');
      }
    }
    maskedInput = maskedInput.join('');
    return maskedInput;
  }

  employedSinceMasking(value) {
    let maskedInput = value.split('');
    if (maskedInput.length > 1) {
      maskedInput.splice(2, 0, '/');
    }
    maskedInput = maskedInput.join('');
    return maskedInput;
  }
}
